import { request } from '@/utils/request'

export function sendCode(data) {
  return request({
    url: '/api/userInfo/sendOtpCode',
    method: 'post',
    data: data
  })
}

export function login(data) {
  return request({
    url: '/api/userInfo/login',
    method: 'post',
    data: data
  })
}

export function userInfo(data) {
	return request({
		url: '/api/userInfo/setUserInfo',
		method: 'POST',
		data
	},true, true)
}

export function userStepData(data) {
	return request({
		url: '/api/userInfo/getUserStepInfo',
		method: 'POST',
		data
	}, true, true)
}



// WEBPACK FOOTER //
// ./src/api/info.js